import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import * as filters from '@/libs/filters'
import myMessage from '@/components/message'
import ugdMessage from '@/view/undergraduate/components/modal/message'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

// 全局filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 全局Message
Vue.prototype.$zlr_message = myMessage.install
// 全局本科Message
Vue.prototype.$ugd_message = ugdMessage.install

// Vue.config.productionTip = false;
Viewer.setDefaults({
  title: false
})
Vue.use(iView)
Vue.use(Viewer)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
